import { Slide } from '@/components/core/Slide';
import audioFile from './24-drones.mp3';
import videoFile from './24-drones.webm';

const autoNextDuration = 57000;
const transcript = `
  En drones! Drones vind je ook geweldig toch?!

  Drones die inspecties uitvoeren kan nu al, zelfs autonoom. Maar straks met de robotisering kunnen die 
  ook echt werk gaan verzetten.

  Stel je voor: drones die niet alleen inspecteren, maar ook direct kleine reparaties uitvoeren aan 
  moeilijk bereikbare plekken zoals hoogspanningsmasten of windturbines.

  Of drones die samenwerken met grondrobots om complexe bouwprojecten uit te voeren, waarbij de drone 
  vanuit de lucht coördineert en materialen aanlevert.

  En wat dacht je van zwermen kleine drones die gezamenlijk grote constructies kunnen bouwen of 
  onderhouden, gecoördineerd door AI?

  Hoe ziet dat er dan uit met al die AI en robotica? Een toekomst waarin mensen en machines naadloos 
  samenwerken, waarbij wij de creatieve en strategische beslissingen nemen, en de machines het 
  gevaarlijke en repetitieve werk uitvoeren.
`;

// Jonathan: [verteld over drones e.d. en vraagt EVA verder te gaan]

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      autoNext={autoNextDuration}
      transition="fade"
      background={{
        video: videoFile,
      }}
    >
      <div className="slide relative z-10">
        {/* <h1 className="text-4xl font-bold mb-10 text-white">🚁 Drones & Robotisering</h1>
        <ul className="space-y-6 text-3xl list-disc text-white bg-black/50 p-6 rounded-lg">
          <li>Autonome inspecties nu al mogelijk</li>
          <li>Toekomst: drones die reparaties uitvoeren</li>
          <li>Samenwerking met grondrobots</li>
          <li>Zwermen drones voor grote constructies</li>
          <li>Mens-machine samenwerking</li>
        </ul> */}
      </div>
    </Slide>
  );
};
